import { ITranslations } from './messages';

export const en: ITranslations = 
{
  X: {
    OK: 'OK',
    CANCEL: 'Cancel',
    EDIT: 'Edit',
    VIEW: 'View',
    YES: 'Yes',
    NO: 'No',
    SAVE: 'Save',
    DELETE: 'Delete',
    SUCCESS: 'Success',
    FAILED: 'Failed',
    FAILED_UNKNOWN: 'Sorry, we are doing some maintenance. Please try again later.',
    SETTINGS: 'Settings',
    ON: 'on',
    OFF: 'off',
    ID: 'ID',
    OR: 'or',
    YOU: 'You',
    YOU_P: 'You',
    OFWHICH: 'of which',
    AND: 'and',
    MORE: 'more',
    LESS: 'less',
    ALERT: 'Alert!',
    SAVED: 'Changes saved',
    ACTIONS: 'Actions',
    TIME: {
      ABOUT: 'about',
      DAYS: '{count, plural, one {# day} other {# days}}',
      HOURS: '{count, plural, one {# hour} other {# hours}}',
      MINUTES: '{count, plural, one {# minute} other {# minutes}}',
      SECONDS: '{count, plural, one {# second} other {# seconds}}',
    },
    SEARCH: {
      ITEM: 'Search item',
      ALL: 'All',
      FILTER: 'Filter by title...',
    },
    ITEMS_PER_PAGE: 'Items/page',
    UNREAD: 'Unread',
    UNREAD_ITEMS: '{count, plural, one {# unread post} other {# unread posts}}',
    TOPDF: 'Save as PDF',
    TODOCX: 'Save as Word',
  },
  GENERAL: {
    CONFIRM: {
      TITLE: 'Confirm',
    },
    DELETE: {
      TITLE: 'Are you sure?',
      FOLDER: {
        DELETE_CNF: 'REALLY DELETE this folder?!',
        CNF: 'Are you sure you want to delete this file?',
        CNF2: 'Permanently erasing folder {foldername}',
        CNF3: 'All files in this folder will also be deleted!',
      },
      FILE: {
        CNF: 'Are you sure you want to delete this file?',
      },
      NOTICE: 'Note that deletion is permanent and cannot be undone.',
      OBJECT: {
        CNF: 'Are you sure you want to delete this?',
        CNF2: 'Note: any content inside will also be deleted!',
      },
    },
    DELETE_ITEM: {
      CONFIRM: 'Are you sure you want to delete this?',
      MODERATION: 'You are moderating someone else\'s content.',
    },
    FORM: {
      REQUIRED: 'Required',
      AUTOCOMPL: 'Enter text or select from suggestions',
      AUTOCOMPL_FDBCK: 'Free input not allowed, please select from suggestions.',
      AUTOCOMPL_NONE: 'No suggestions available.',
      AUTOCOMPL_PLCH: 'Type here...',
      NODATE: 'No date available',
      EDITING: 'editing',
      ROWS_EDITING: 'editing {count, plural, one {# row} other {# rows}}',
    },
    MARKDOWN: {
      MD_LINK: 'Read here about Markdown',
      MD_EXPLAINER: 'This text is formatted using Markdown for, e.g., **bold** or *italics* text.',
      MD_EXPLAINER_2: 'Make a link with [link text](https://example.com) and a new line with two spaces at the end of a line.',
    },
    STATUS: {
      STATUS: 'Status',
      CONCEPT: 'Concept',
      ACTIVE: 'Active',
      PUBLISHED: 'Published',
      FINISHED: 'Finished',
      ARCHIVED: 'Archived',
      FORMER: 'Former',
    },
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    DATES: {
      START: 'Start',
      END: 'End',
      DURATION: 'Duration',
    },
    IMAGE: 'Image',
    IMAGE_CONTAIN: 'Zoom out image',
    RELOADING: 'Reloading...',
    LOCALE: {
      LABEL: 'Language',
      NL: 'Dutch (nl)',
      EN: 'English (en)',
      PT: 'Portuguese (pt)',
      SHORT: {
        NL: 'NL',
        EN: 'EN',
        PT: 'PT',
      },
    },
    AUTHOR: 'Author',
    EDITING_LIVE_WARNING: 'You are editing live content that is visible to the public. There is no "save" or "undo" button — changes you make are instantly published.',
    IMAGE_UPLOAD_SUCCESS: 'Image uploaded successfully.',
    IMAGE_UPLOAD_FAILED: 'Image upload failed. Please try again later.',
    UNSAVED_IMG: 'Please upload the image before leaving edit mode.',
    DELETE_IMAGE_CNF: 'Are you sure you want to delete this image?',
    DOWNLOAD: 'Download',
    SORTING_HINT: 'Sort items by date, this will be saved.',
    SINCE: 'since {date}',
  },
  NAVIGATION: {
    HOME: 'Home',
    ADMIN: 'Admin',
    ADMIN_MENU: {
      EDIT_PROJECT: 'Edit project',
      NEW_PROJECT: 'New project',
      EDIT_DIALOGUE: 'Edit dialogue',
      RESET_ORDER: 'Reset order',
      RESET_ORDER_BLOCKS: 'Reset block order',
      USERS: 'Users',
      PROJECTS: 'Projects',
      SETTINGS: 'App Settings',
      SLUGS: 'Project slugs',
      DEMO_MODE: 'Demo mode',
      SHOW_IDS: 'Block id\'s',
      DEBUGPANEL: 'Debug panel',
      UPDATE_CONTENT_TYPE: 'Update content type in Blob Storage',
      MAILINGS: 'Mailings',
      MAILING: 'New mailing',
      CREATE_MENU: 'Create menu',
    },
    SETTINGS: 'Settings',
    LOGOUT: 'Log out',
    LOGIN: 'Log in',
    SIGNUP: 'Register',
    MY_PROFILE: 'My profile',
    OVERVIEW: 'Overview',
    THIS_DIALOGUE: 'This dialogue',
    ABOUT: 'About us',
    HELP: {
      HELP: 'Help',
      GENERAL: 'Help with dialogues',
      TOOLS: 'Help with tools',
      PRIVACY: 'Your privacy',
      CONSENT: 'Your consent',
      WELCOME: 'Back to home page',
    },
    ERROR_404: {
      TITLE: 'Aw, we\'re confused...',
      TEXT1: 'That page you\'re asking for...',
      TEXT2: 'We cannot find it.',
      BACK: 'Please go back one page,',
      HOME: 'or return to the home page.',
    },
    ERROR_CONNECTION: {
      TITLE: 'Oh dear, the connection is gone.',
      LEVEL1: 'We are trying to reconnect, hang on...',
      LEVEL2: 'And we could not restore it yet. Check your network please and then',
      RELOAD: 'try reloading the page.',
    },
    FOR_EVERYONE: 'For everyone',
    MODERATION: 'Moderation',
    LOADER: {
      DIALOGUE: 'Dialogue is loading...',
      PROJECTS: 'Projects are loading...',
      APPLICATION: 'Application is initializing...',
      UNAVAILABLE: 'We cannot reach Civic Technology...\nIs your internet connection active?',
      MAINTENANCE: 'We are performing maintenance on the servers...\nSorry for the inconvenience, please try again later.',
    },
    RESTRICTED: 'Log in to view this page',
  },
  ADMIN: {
    SETTINGS: {
      FORM_TITLE: 'Settings for the entire platform',
      USERS: {
        RIGHTS: 'User rights',
      },
      MODERATORS: {
        TOOLS: 'Tools',
        TOOLS_AVAILABLE: 'Tools available to moderators',
        LISTTYPES: 'List types',
      },
      MAXMBS: {
        UPLOADS: 'Uploads',
        TITLE: 'Maximum upload sizes in MB\'s',
        IMG: 'Images',
        DOC: 'Word docs',
        XLS: 'Excel docs',
        PPT: 'Powerpoints',
        PDF: 'PDF\'s',
        DEFAULT: 'Using default ({default} MB)',
      },
      CONFIG: {
        TITLE: 'Configuration',
        ASYNC_PINGS: 'Enable async pings',
        NOTIFICATIONS_ENABLED: 'Enable notifications',
        DEBUG_PANEL: 'Show debug panel (this window only)',
        MAINTENANCE_MODE: 'Maintenance mode - currently {mode}',
      },
    },
    MAINTENANCE_MODE: {
      AUTH_REQUIRED: 'Administrator access only.',
      UNAUTHORIZED: 'You are not authorized to perform this action.',
      FORBIDDEN: 'You do not have permission to perform this action.',
      TITLE: 'Maintenance Mode',
      STATUS: 'Current Status',
      DISABLED: 'Disabled',
      ENABLED: 'Enabled',
      TOGGLE_LABEL: 'Enable Maintenance Mode',
      INFO: 'When maintenance mode is enabled, regular users will see a maintenance screen and cannot access the application. Administrators can still access the admin maintenance page to disable maintenance mode.',
    },
    USERS: {
      FORM_TITLE: 'User administration',
      SEARCH_PLCH: 'Search users by name or email',
      UNSUBSCRIBE: 'Unsubscribe',
    },
    DEBUG_PANEL: {
      SETTINGS: 'Settings',
      REDUX_STATE: 'Redux State',
      PROPS: 'Props',
      DEBUG: 'Debug',
      DRAG_PREVIEW: 'Drag preview',
      RELOAD: 'Refresh Redux state',
      TOGGLE_FULL_STATE: 'Toggle between curated and full state',
    },
    SITE_CONFIG: {
      TITLE: 'Site configuration',
      TAB_MENUS: 'Menus',
      TAB_PAGES: 'Pages',
      TAB_STYLING: 'Styling',
    }
  },
  FILES: {
    EDIT: 'Edit description',
    DESCRIPTION_DIALOGUE: 'File/link description',
    DESCRIPTION_PROJECT: 'Project file description',
    DESCRIPTION: 'Description',
    UPLOAD: {
      TOO_LARGE: 'File is too large: maximum size is {sizeallowed} MB.',
      WRONG_TYPE: 'Please upload a file of type: {typesallowed}.',
    },
    NO_FILE: 'Click on the + to select a file, or include a web link in the description.',
    NO_DESCRIPTION: 'Provide a name or short description.',
    COPY_PATH: 'Copy path',
  },
  MENUS: {
    MENUS: 'Menus',
    NEW_MENU: 'New menu',
    EDIT: 'Edit menu',
    EDIT_MENU: 'Edit menu {menu}',
    NONE: 'There are no menus yet.',
    FORM: {
      NEW: 'Create a new menu',
      TITLE_LABEL: 'Title',
      TITLE_PLCH: 'Title of the menu',
      CONFLICT: 'A menu with this title already exists. Please choose a different title.',
      MAINMENU: 'Use \'MainMenu\' to show this menu in the main navigation bar.',
    },
    DELETE_CONFIRM: 'Are you sure you want to delete the menu \'{menu}\'?',
    DELETE_CONFIRM_2: 'All menu items in this menu will also be deleted!',
    ITEMS: {
      NEW: 'New menu item',
      NEW_IN_MENU: 'New menu item in {menu}',
      EDIT: 'Edit menu item',
      EDIT_IN_MENU: 'Edit menu item in {menu}',
      TITLE_LABEL: 'Title',
      TITLE_PLCH: 'Title of the menu item',
      SLUG_LABEL: 'Slug',
      SLUG_PLCH: 'Slug of the menu item (e.g., /about-us)',
      TEXT_LABEL: 'Text',
      TEXT_PLCH: 'Hint text for the menu item (optional)',
      CONFLICT: 'A menu item with this title already exists in this menu. Please choose a different title.',
      DELETE_CONFIRM: 'Are you sure you want to delete the menu item `{item}`?'
    }
  },
  PAGES: {
    PAGES: 'Pages',
    NONE: 'There are no pages yet.',
    NEW_PAGE: 'New page',
    EDIT_MODE: 'Edit',
    SORT_MODE: 'Sort',
    PREVIEW_MODE: 'View',
    FORM: {
      NEW: 'Create a new page',
      TITLE_LABEL: 'Title',
      TITLE_PLCH: 'Title of the page',
      SLUG_LABEL: 'Slug',
      SLUG_PLCH: 'Slug of the page (e.g., /about-us)',
    },
    EDIT: 'Edit page',
    DELETE_CONFIRM: 'Are you sure you want to delete page `{page}`?',
    DELETE_CONFIRM_2: 'All content on this page will also be deleted!',
    SECTIONS: {
      COUNT: '{count, plural, one {# section} other {# sections}}',
      DELETE_CONFIRM: 'Are you sure you want to delete this section?',
      DELETE_CONFIRM_2: 'All content in this section will also be deleted!',
    },
    ADD_SECTION: 'Add section',
    REMOVE_SECTION: 'Remove section',
  },
  PROJECTS: {
    PROJECTS: 'Projects at Civic Technology',
    NONE: 'There are no projects yet.',
    ADD_PROJECT: 'Add project',
    REMOVE_PROJECT: 'Remove project',
    DELETE_CONFIRM: 'Are you sure you want to delete this project?',
    DELETE_CONFIRM_2: 'All content in this project will also be deleted!',
    TITLE_EN_PLCH: 'Project title (English)',
    TITLE_NL_PLCH: 'Project title (Dutch)',
    TEXT_EN_PLCH: 'Project description (English)',
    TEXT_NL_PLCH: 'Project description (Dutch)',
    PUBLICATIONS: 'Publications in this project',
    },
  PUBLICATIONS: {
    PUBLICATIONS: 'Publications at Civic Technology',
    NONE: 'There are no publications yet.',
    ADD_PUBLICATION: 'Add publication',
    REMOVE_PUBLICATION: 'Remove publication',
    DELETE_CONFIRM: 'Are you sure you want to delete this publication?',
    DELETE_CONFIRM_2: 'All content in this publication will also be deleted!',
    TITLE_PLCH: 'Title',
    TEXT_PLCH: 'Citation text for the publication',
    PUBLICATION_DATE: 'Publication date',
    SORT_BY_DATE: 'Sort by date',
    SELECT: 'Select publications',
  },
  TEAM: {
    MEMBERS: 'The Civic Tech research team',
    NONE: 'There are no team members yet.',
    ADD_MEMBER: 'Add team member',
    REMOVE_MEMBER: 'Remove team member',
    DELETE_CONFIRM: 'Are you sure you want to delete this team member?',
    DELETE_CONFIRM_2: 'All information for this team member will also be deleted!',
    SORT_BY_TIME: 'Sort by start date',
    SORT_BY_NAME: 'Sort by name',
    PUBLICATIONS: 'Selected publications',
  },
  LIBRARY: {
    LIBRARY: 'Library',
    UPLOAD: {
      DOCUMENT: 'Upload document',
      IMAGE: 'Upload image',
      VIDEO: 'Create video message',
      AUDIO: 'Create audio message',
      SUBMIT: 'Submit',
    },
    FOLDERS: {
      CREATE: 'New folder',
      NAME: 'Folder name',
      REQUIRED: 'A folder name is required.',
      CONFLICT: 'A folder with this name already exists.',
      INVALID: 'This folder name contains invalid characters.',
      SUCCESS: 'Folder created!',
      EDIT: 'Rename',
      REQUIRESCONVERSION: 'The library requires adjustment by a moderator.',
      NO_ROOT_FOLDER: 'No root folder found. Please report this to the admin.',
    },
    SUMMARY: {
      SUMMARY: 'Summary',
      GENERATE: 'Generate summary',
      GENERATING: 'Summary is being generated...',
      EDIT: 'Edit summary',
      DISCLAIMER: 'Please note: this summary has been generated with the use of AI and may contain mistakes or incorrect information. Read the original document for accurate information.',
      UNSUPPORTED: 'Summary not generated, this file type is not supported.',
      TOOLARGE: 'Summary not generated, this document is too large for us, sorry!',
      NO_INPUT: 'Summary not generated, this document has no text content. Perhaps it only contains images.',
      UNAVAILABLE: 'Sorry, a summary is currently not available.',
      PARTIAL_WARNING: 'Warning: the document could not be summarized completely. We\'ve covered {percentage}%.',
      GENERATED: 'AI version',
      EDITED: 'Your version',
      SAVE_EDITED: 'Save your version',
      KEEP_AI: 'Keep AI version',
      DELETE: 'Delete summary',
      DELETE_YOUR: 'Do you want to permanently delete the summary you edited?',
      DELETE_AI: 'Do you want to permanently delete the AI-generated summary?',
      COMPLEXITY: {
        LABEL: 'Desired language complexity',
        ORIGINAL: 'As the original',
        MODERATE: 'Moderate',
        SIMPLE: 'Simple',
      },
      LENGTH: {
        LABEL: 'Desired length',
        SHORT: '3-4 sentences',
        MEDIUM: '2 paragraphs',
        LONG: '4-5 paragraphs',
      },
    },
  },
  DOCUMENT: {
    FORM: {
      NEW: 'Create a new document',
      TITLE_PLCH: 'Title of the document',
      READONLY: 'Read-only for participants',
    },
    SEE_ANNEX: 'See annex',
  },
  USERS: {
    ROLES: {
      ADMIN: 'Admin',
      ADMINS: 'Admins',
      MANAGER: 'Manager',
      MANAGERS: 'Managers',
      MODERATOR: 'Moderator',
      MODERATORS: 'Moderators',
      PARTICIPANT: 'Participant',
      PARTICIPANTS: 'Participants',
      GUEST: 'Guest',
      GUESTS: 'Guests',
      YOU_ARE_MODERATOR: 'You are moderator',
      MAKE_MODERATOR: 'Make moderator',
    },
    FORM: {
      TITLE: 'User Administration',
      USER_COUNT: '{count, plural, one {# User} other {# Users}}',
      PURGE_INACTIVE: 'Delete {purge} of {count} inactive guests',
      PURGE_INACTIVE_CNF: 'Are you sure you want to delete {purge, plural, one {# inactive guest} other {# inactive guests}}?',
      PURGE_INACTIVE_SUCCESS: '{purge, plural, one {# inactive guest} other {# inactive guests}} have been deleted.',
      USER_SETTINGS: 'User Settings',
      VERIFIED: 'Verified',
      ADD_USER: 'New user',
      DELETE_USER: 'Delete user',
      DELETE_USER_CONF: 'Are you sure to delete this user?',
      DELETE_USER_CONF_2: 'All information for this user will be deleted and cannot be be recovered!',
      NAME: 'Name',
      EMAIL: 'Email',
      ROLE: 'Role',
      LAST_LOGIN: 'Last login',
      SORT: {
        SORT: 'Sort users ',
        ID: 'by ID',
        NAME: 'by Name',
        EMAIL: 'by Email',
        ROLE: 'by Role',
        LAST_LOGIN: 'by Last login',
        ASC: 'ascending',
        DESC: 'descending',
      },
      SUBSCRIPTIONS: 'Subscriptions',
      ACTIVITY: {
        MESSAGES: 'Messages',
        VOTES: 'Votes & Likes',
        FILES: 'Files',
      },
      PROJECTS: 'Projects',
      PROJECT: 'Project',
      NO_PROJECTS: 'No projects',
      ADD_PROJECT: 'Add project',
      DIALOGUES: 'Dialogues',
      DIALOGUE: 'Dialogue',
      NO_DIALOGUES: 'No dialogues',
      ADD_DIALOGUE: 'Add dialogue',
      MODERATOR: 'Moderator',
      MISSING_PROJECTS: 'Missing project id\'s',
      MISSING_DIALOGUES: 'Missing dialogue id\'s',
    },
    CONSENT: {
      CONSENT: 'I am 18 years or older and agree to the',
      CONSENT_READ: 'Read the',
      CONSENT_LINK: 'terms and conditions of Civic Technology',
    },
    SIGNUP: {
      FORM_TITLE: 'Welcome to Civic Technology!',
      FORM_TITLE_COMPACT: 'Make an account for Civic Technology!',
      NAME: 'Your name',
      NAME_INSTR: 'At Civic Technology we share our names with each other.',
      NAME_HINT: 'Use at least 4 letters. Your name will be visible to other users.',
      NAME_FDBCK: 'Please enter at least 4 characters. You can use letters, hyphens and spaces, but no numbers or other characters and no spaces at beginning or end.',
      EMAIL_IN_USE: 'Email address already in use. Try logging in.',
      WELCOME: 'Welcome',
      WELCOME_NAMED: 'Hello {name}',
      USER_INSTR: 'Your data',
      EMAIL_INSTR: 'The email address you use to log in',
      EMAIL_HINT: 'We share this with no-one.',
      EMAIL_HINT2: 'We share this with no-one. If you want, we can notify you by email when there are new posts. Set this in your profile.',
      EMAIL_FDBCK: 'Please provide a valid email address.',
      PASSWORD_INSTR: 'Choose a password',
      PASSWORD_HINT: 'Minimum 8 characters, at least one lower case and one upper case letter and at least one number.',
      PASSWORD_FDBCK: 'Please check the rules above for a valid password.',
      SUBMIT_INSTR: 'Almost there...',
      SUBMIT: 'Create account',
      SUBMIT_CODE: 'Confirm account',
      HAVE_ACCOUNT: 'Already have an account? Then log in here.',
      FAILED: 'An error occurred during signup. Could you have registered before already and forgot your password? Otherwise please try again.',
      CODE: 'Confirmation code',
      CODE_HINT: 'Check your email! That\'s where you\'ll find the code. Also check your spam folder.',
      CODE_INSTR: 'We have sent you a code by email. Enter it here to complete your registration.',
      CODE_PLCH: 'enter the code',
      CODE_FAILED: 'The code is not correct. Please check that you entered the correct code from the email.',
      CODE_SUCCESS: 'Code accepted. Your registration is complete.',
      REGCODE: 'Registration code',
      REGCODE_INSTR: 'Do you have a registration code?',
      REGCODE_PLCH: 'enter the code',
      WITH_REGCODE: 'Yes',
      REGCODE_FDBCK: 'Please enter the registration code you received.',
      WITHOUT_REGCODE: 'No',
      SUCCESS: 'Registration successful. You can now log in.',
      SUCCESS_GUEST: 'Registration as guest successful. You can now participate.',
      SUCCESS_VER: 'Registration successful. Check your email, we have sent instructions for the next step.',
      SUCCESS_VER_REGCODE_LIST: 'Registration successful. Check your email, we have sent instructions for the next step. These registration codes do not exist:',
      FAILED_CODE: 'This registration code is not correct. Please verify that you entered the code correctly.',
      PROJECT: {
        WELCOME_NAMED: 'Welcome to the project {projectName}.',
        INSTR: 'You have been invited to join this dialogue!',
        INSTR2: 'Follow the steps below to participate.',
        HOW: 'How do you want to join?',
        TAB_ACCOUNT: 'I want to make an account',
        TAB_ACCOUNT2: 'With an account, you can come back later to participate again.',
        TAB_GUEST2: 'As a guest, you participate just once, without an account.',
        TAB_GUEST: 'I will join as guest',
        TAB_HAVE_ACCOUNT: 'I already have an account',
        TAB_HAVE_ACCOUNT2: 'Log in with your email and password.',
        LOGGED_IN: 'Welcome {name}! You are logged in and can now participate in the dialogue.',
        SELECT_DIALOGUE: 'Select the dialogue you want to participate in',
        SELECT_DIALOGUE_PLCH: 'Select dialogue',
        CODE: 'Enter the access code you received',
        CODE_PLCH: 'access code',
      },
    },
    GUESTS: {
      FORM_TITLE_COMPACT: 'Join as a guest at Civic Technology!',
      INSTR: 'How do you want to participate?',
      GUEST: 'Just once, as guest',
      USER: 'With an account so I can return later',
      MAKE_ACCOUNT: 'As guest, you participate just once, without an account. If you want to return to this dialogue later,',
      MAKE_ACCOUNT_LINK: 'make an account now.',
      SUBMIT: 'Register as guest',
      EDIT: 'Create an account',
      UPGRADED: 'We sent you an email to confirm your address.',
      GIVE_NAME: 'Give me a name',
    },
    CONFIRM: {
      TITLE: 'Email verification',
      TEXT: 'Your email address is being confirmed...',
      SUCCESS: 'Verifcation successful, you can now log in.',
      FAILED: 'Verification failed, please check the verification link in your email.',
    },
    LOGIN: {
      FORM_TITLE: 'Welcome back!',
      EMAIL: 'Your email address',
      EMAIL_FDBCK: 'Please provide a valid email address.',
      PASSWORD: 'Password',
      PASSWORD_FDBCK: 'Type the password that you chose during signup.',
      SUBMIT: 'Log in',
      OTHER_OPTIONS: 'Or ... ',
      FORGOT: 'Did you forget your password?',
      NO_ACCOUNT: 'Are you new here?',
      NEW_USER: 'I have no account yet',
      UNVERIFIED: 'Your email address was not verified. Have you confirmed your email address via the email we sent you?',
      FAILED: 'Login failed. Are your email address and password correct?',
      LOCKED: 'Your account is temporarily blocked. Please try again later.',
    },
    FORGOT: {
      FORM_TITLE: 'If you forgot your password...',
      FORM_TEXT: 'We will send you a link by email that you can use to set a new password.',
      SUBMIT: 'Get link',
      TRY_AGAIN: 'Try to log in again?',
      SUCCESS: 'If your email address was registered with us, instructions have now been sent to your address.',
    },
    RESET: {
      FORM_TITLE: 'Seting a new password',
      PASSWORD: 'Choose a new password',
      PASSWORD2: 'The same password again',
      SUBMIT: 'Confirm new password',
      SUCCESS: 'Your new password has been saved, you can now log in.',
      NOMATCH: 'The passwords do not match. Type the same password twice.',
      FAILED: 'Your password could not be set. Please try again.',
      REMEMBERED: 'Try your old password again?',
    },
    PROFILE: {
      TABS: {
        PROFILE: 'Profile',
        NOTIFICATIONS: 'Notifications',
        LANGUAGE: 'Language',
        LOGIN: 'Login data',
      },
      NAME: 'Name',
      NAME_PLCH: 'Full name and titles',
      FIRSTNAME_PLCH: 'First name',
      FUNCTION_PLCH: 'Function',
      LINKEDIN_PLCH: 'LinkedIn url',
      LINKEDIN: 'LinkedIn profile',
      ORCID_PLCH: 'ORCID url',
      ORCID: 'ORCID',
      EMAIL: 'Email',
      EMAIL_INSTR: 'Your email address will not be visible to others.',
      EMAIL_PLCH: 'you@example.com',
      ABOUT_INSTR: 'Share something about yourself so others get to know you better.',
      ABOUT_PLCH: 'Write something about yourself...',
      RESETPWD_INSTR: 'Do you want to change your password?',
      RESETPWD: 'Yes, send me instructions for resetting my password',
      DELETE_AVATAR_CNF: 'Please confirm deleting your profile picture',
    },
    NOTIFICATIONS: {
      TITLE: 'Email notifications',
      ENABLE: 'I want to receive notifications by email about news in my dialogues.',
      INSTR: 'Select when to receive the emails:',
      EVERYDAY: 'Every day',
      PARTOFDAY: {
        MOR: 'Morning',
        AFT: 'Afternoon',
        EVE: 'Evening',
      },
      NO_DAYS_OR_HOURS: 'Choose days and times for notifications, otherwise they will not be sent.',
      IN_SPAM: 'Check your spam folder if you do not receive notifications.',
      MODIFY: 'Modify user notifications',
    },
    LOCALE: {
      LANGUAGE: 'Language',
      LANGUAGE_INSTR: 'Language for menu and buttons of this website.',
      TRANSLATION_NO: 'Projects and dialogues are not translated.',
      TRANSLATION_INSTR: 'This is also the language used for dialogue translations for you.',
      NO_TRANSLATION: 'Languages you understand',
      NO_TRANSLATION_INSTR: 'Languages you select here will not be translated',
    },
    REGCODE: {
      FORM_TITLE: 'Add a registration code',
      INSTR: 'Have you received a registration code for a project or dialogue? You can enter it here.',
      SUBMIT: 'Register code',
      SUCCESS: 'Registration code processed, you can now participate!',
      FAILED: 'Registration code is not accepted, correct the code and try again.',
    },
    ANONYMOUS: {
      IDENTIFIER: 'Anonymous',
      LETTER_FROM: '1',
      NAMES: 'Anonymous Rose, Anonymous Tulip, Anonymous Lily, Anonymous Daisy, Anonymous Sunflower, Anonymous Orchid, Anonymous Daffodil, Anonymous Marigold, Anonymous Chrysanthemum, Anonymous Iris, Anonymous Peony, Anonymous Lavender, Anonymous Poppy, Anonymous Hibiscus, Anonymous Violet, Anonymous Gardenia, Anonymous Magnolia, Anonymous Jasmine, Anonymous Hydrangea, Anonymous Geranium, Anonymous Begonia, Anonymous Petunia, Anonymous Azalea, Anonymous Lilac, Anonymous Anemone, Anonymous Zinnia, Anonymous Camellia, Anonymous Snapdragon, Anonymous Gladiolus, Anonymous Basil, Anonymous Rosemary, Anonymous Thyme, Anonymous Mint, Anonymous Oregano, Anonymous Sage, Anonymous Parsley, Anonymous Cilantro, Anonymous Dill, Anonymous Chives, Anonymous Eucalyptus, Anonymous Maple, Anonymous Oak, Anonymous Pine, Anonymous Birch, Anonymous Willow, Anonymous Cedar, Anonymous Spruce, Anonymous Fir, Anonymous Redwood, Anonymous Cypress, Anonymous Holly, Anonymous Magnolia, Anonymous Dogwood, Anonymous Ash, Anonymous Beech, Anonymous Elm, Anonymous Cherry, Anonymous Apple, Anonymous Banana, Anonymous Orange, Anonymous Mango, Anonymous Strawberry, Anonymous Blueberry, Anonymous Raspberry, Anonymous Cherry, Anonymous Grape, Anonymous Pineapple, Anonymous Watermelon, Anonymous Peach, Anonymous Plum, Anonymous Kiwi, Anonymous Papaya, Anonymous Pear, Anonymous Pomegranate, Anonymous Lemon, Anonymous Lime, Anonymous Coconut, Anonymous Carrot, Anonymous Tomato, Anonymous Lettuce, Anonymous Broccoli, Anonymous Cucumber, Anonymous Pepper, Anonymous Spinach, Anonymous Zucchini, Anonymous Eggplant, Anonymous Pumpkin, Anonymous Rhododendron, Anonymous Azalea, Anonymous Boxwood, Anonymous Forsythia, Anonymous Hydrangea, Anonymous Juniper, Anonymous Privet, Anonymous Viburnum, Anonymous Spirea, Anonymous Hazel, Anonymous Ivy, Anonymous Clematis, Anonymous Wisteria, Anonymous Bougainvillea, Anonymous Honeysuckle, Anonymous Passionflower, Anonymous Pea, Anonymous Bamboo, Anonymous Grass, Anonymous Zoysia, Anonymous Switchgrass, Anonymous Miscanthus, Anonymous Aloe Vera, Anonymous Jade, Anonymous Echeveria, Anonymous Agave, Anonymous Sedum, Anonymous Haworthia, Anonymous Kalanchoe, Anonymous Aeonium, Anonymous Sempervivum, Anonymous Crassula',
    },
  },
};

export default en;
